import { render, staticRenderFns } from "./U_VideoBussiness.vue?vue&type=template&id=6054ed88&scoped=true&"
import script from "./U_VideoBussiness.vue?vue&type=script&lang=js&"
export * from "./U_VideoBussiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054ed88",
  null
  
)

export default component.exports